import { Bean, NumberPatternType, ValidationRules } from '@dreryk/react-common';
import { InteractiveTable, InteractiveTableCellProps } from '@dreryk/react-components';

import { serviceSettingsTranslationKeys } from '../../../../../translations';

const t = serviceSettingsTranslationKeys.advancePayments.form.timeBasedRefundInteractiveTable.refundPercentage;
const MIN = 0;
const MAX = 100;
const VALIDATION_RULES: ValidationRules<Bean> = {
   required: true,
   max: { value: MAX, message: t.validationMessage.max },
   min: { value: MIN, message: t.validationMessage.min },
};

type RefundPercentageCellProps = InteractiveTableCellProps<number>;

export const RefundPercentageCell = (props: RefundPercentageCellProps): JSX.Element => {
   return (
      <InteractiveTable.NumberInputCell
         index={props.index}
         name='refundPercentage'
         testId={'refundPercentage'}
         min={MIN}
         max={MAX}
         pattern={NumberPatternType.POSITIVE_INTEGER}
         defaultValue={props.defaultValue}
         placeholder={t.placeholder}
         validationRules={VALIDATION_RULES}
      />
   );
};
